import React from "react";
import "./css/index.css";

type Props = {
  isActive: boolean;
  updateActive: (e: boolean, index: number) => void;
  index: number;
};

const ToggleBtn = ({ isActive, updateActive, index }: Props) => {
  return (
    <button
      className={`toggle-btn ${isActive ? "active-toggle" : ""}`}
      onClick={() => {
        updateActive(!isActive, index);
      }}
    >
      <div className="toggle-circle" />
    </button>
  );
};

export default ToggleBtn;
